/*
 * @Description: 投资必读
 * @Autor: lichao
 * @Date: 2022-01-18 09:13:15
 * @LastEditors: lichao
 * @LastEditTime: 2022-02-17 15:13:15
 */
import { Fragment } from "react";
import { Switch } from "react-router-dom";
import { renderRoutes } from "../../router/index";
import "./index.less";
const Read = (props) => {
  return (
    <Fragment>
      <Switch>{renderRoutes(props.routes)}</Switch>
    </Fragment>
  );
};
export default Read;
